export default __webpack_public_path__ + "static/media/q26_step6.438d9ea5.png";